// FLO 차트 공용 상수.

// 노드 종류(사이드바/레이아웃에서 분기 기준으로 사용)
export const FLO_KIND = { ITEM: "item", ROUTE: "route", RESOURCE: "resource" };
